// Shared by gatsby-node.js (CommonJS) and the browser bundle.
//
// Japanese lives at the site root so existing URLs (/, /contact/, /services/) keep working.
// Every other locale is served under its prefix, e.g. /en/about/.
const LOCALES = {
  ja: {
    prefix: "",
    htmlLang: "ja",
    ogLocale: "ja_JP",
    label: "日本語",
    short: "JA",
  },
  en: {
    prefix: "/en",
    htmlLang: "en",
    ogLocale: "en_US",
    label: "English",
    short: "EN",
  },
  pt: {
    prefix: "/pt",
    htmlLang: "pt-BR",
    ogLocale: "pt_BR",
    label: "Português",
    short: "PT",
  },
}

const DEFAULT_LOCALE = "ja"

// Locales every page in src/pages is built in. Portuguese is opt-in: games declare it in
// their game.yaml, pages in src/pages are listed here by path.
const SITE_LOCALES = ["ja", "en"]
const PAGE_LOCALES = {
  "/": ["ja", "en", "pt"],
}

// Where to send someone when a page doesn't exist in their language.
const FALLBACK = { pt: "en", en: "ja", ja: null }

const localizedPath = (basePath, lang) => `${LOCALES[lang].prefix}${basePath}`

// "/en/about/" -> { lang: "en", basePath: "/about/" }
const splitPath = path => {
  for (const [lang, { prefix }] of Object.entries(LOCALES)) {
    if (prefix && (path === prefix || path.startsWith(`${prefix}/`))) {
      return { lang, basePath: path.slice(prefix.length) || "/" }
    }
  }
  return { lang: DEFAULT_LOCALE, basePath: path }
}

module.exports = {
  LOCALES,
  DEFAULT_LOCALE,
  SITE_LOCALES,
  PAGE_LOCALES,
  FALLBACK,
  localizedPath,
  splitPath,
}
